import { render, staticRenderFns } from "./HistoryTabs.vue?vue&type=template&id=2cfb0b2c&scoped=true&"
import script from "./HistoryTabs.vue?vue&type=script&lang=js&"
export * from "./HistoryTabs.vue?vue&type=script&lang=js&"
import style0 from "./HistoryTabs.vue?vue&type=style&index=0&id=2cfb0b2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfb0b2c",
  null
  
)

export default component.exports